<template>
    <div class=audio-tour>

        <Slideshow
            ref=slider
            :slides="slides"
            :settings="settings"
            @next-slide="nextTrack"
            @prev-slide="prevTrack"
            @slide-change="slideChange"
        >
        </Slideshow>

        <SoundCloudEmbed ref=player @playing="playing" @finished="nextSlide"></SoundCloudEmbed>


    </div>
</template>
<script>
import Slideshow from './Slideshow.vue'
import SoundCloudEmbed from './SoundCloudEmbed.vue'

export default {
    name : 'AudioTour',
    props : {
        slides : Array,
    },
    data() {
        return {
            settings : {
                loop            : false ,
                spaceBetween    : 100   ,
                allowTouchMove  : false ,
                navigation      : false ,
                slidesPerView   : 1,
            },
            suppressCustomEvents : false,
        }
    },
    components : {
        Slideshow,
        SoundCloudEmbed,
    },
    methods : {
        playing( index ) {
            this.$refs.slider.slideTo( index );
        },
        nextTrack() {
            this.$refs.player.next();
        },
        prevTrack() {
            this.$refs.player.prev();
        },
        nextSlide() {
            this.$refs.slider.slideNext();
        },
        slideChange( index ) {
            this.$refs.player.skipTo( index || 0 );
        },
    }
}
</script>